import { useEffect } from "react";
import { gsap } from "gsap";

interface MoveDownAnimationProps {
    svgElement: SVGElement;
    animationSpeed: number;
    moveDistance: number,
  }
  const MoveDownAnimation: React.FC<MoveDownAnimationProps> = ({
    svgElement,
    moveDistance = 20,
    animationSpeed = 1,
  }) => {
    useEffect(() => {
      gsap.to(svgElement, {
        y: `+=${moveDistance}`,
        duration: animationSpeed,
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
      });
    }, [svgElement, moveDistance, animationSpeed]);
  
    return null;
  };
  
  
export default MoveDownAnimation;
